import animation, { cubicBezier } from "@constants/animation"
import colors from "@constants/colors"
import { body14Styles, smallcapsBold13Styles } from "@constants/typography"
import { getShopURLForBrandDeviceType } from "@utils/urls"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  ${smallcapsBold13Styles}
  display: flex;
  height: 40px;
  margin-bottom: 10px;
  padding: 4px 12px 0;
  align-items: center;
  background-color: transparent;
`

const Brand = styled(Link)`
  ${body14Styles}
  display: inline-flex;
  padding: 0 12px;
  align-items: flex-start;
  color: ${colors.mediumDarkGray};
  line-height: 32px;
  transition: background-color ${animation.medium} ${cubicBezier};
  background-color: transparent;

  &:hover {
    transition: background-color ${animation.quick} ${cubicBezier};
    background-color: ${colors.dividerLineGray};
  }
`

interface SeriesListProps {
  brands: Array<{
    brandName: string
    brandSlug: string
  }>
  deviceType: string
  header: string
}

const SeriesList: React.FC<SeriesListProps> = ({
  brands,
  deviceType,
  header,
}) => {
  return (
    <Container>
      <Header>{header}</Header>
      {brands.map((brand) => (
        <Brand
          key={`${deviceType}-${brand.brandSlug}`}
          to={getShopURLForBrandDeviceType(brand.brandSlug, deviceType)}
        >
          {brand.brandName}
        </Brand>
      ))}
    </Container>
  )
}

export default SeriesList
